export default __webpack_public_path__ + "static/media/a016-market-1.b6989912.jpg";